import { Button } from 'antd';
import {
  CopyOutlined,
  CheckOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

/**
 *
 * @param root0
 * @param root0.onClick
 * @param root0.disabled
 */
export default function CopyButton({
  disabled,
  onClick,
  save,
  isNextMode = false,
  isDoneMode = false,
}: {
  disabled: boolean;
  onClick: () => void;
  save: boolean;
  isNextMode?: boolean;
  isDoneMode?: boolean;
}) {
  const { t } = useTranslation();

  const [copiedState, setCopiedState] = useState(false);

  const getButtonTitle = (): string => {
    if (isNextMode) {
      return t`Autosummary.nextButton.title`;
    }
    if (isDoneMode) {
      return t`Autosummary.doneButton.title`;
    }

    return save
      ? t`Autosummary.copyButton.title.copyAndSave`
      : t`Autosummary.copyButton.title.copy`;
  };

  const getButtonIcon = () => {
    if (copiedState) {
      return <CheckOutlined />;
    }
    if (isNextMode) {
      return <ArrowRightOutlined />;
    }
    if (isDoneMode) {
      return <CheckCircleOutlined />;
    }

    return <CopyOutlined />;
  };

  return (
    <Button
      disabled={disabled}
      className="mt-4 w-fit"
      type="primary"
      icon={getButtonIcon()}
      onClick={async () => {
        onClick();
        if (!isNextMode && !isDoneMode) {
          setCopiedState(true);
          setTimeout(() => {
            setCopiedState(false);
          }, 3000);
        }
      }}
    >
      {!copiedState ? getButtonTitle() : t`Autosummary.copyButton.action.title`}
    </Button>
  );
}
